import { useLocation } from 'react-router-dom';
import { TabsContainer } from '@/components/TabView/Tabs';

type Props = {
  paths?: {
    preview: string;
    summary: string;
    details: string;
    references: string;
  };
};

export const FileTabViewContainer = ({
  paths = {
    preview: `preview`,
    summary: `summary`,
    details: `details`,
    references: `references`,
  },
}: Props) => {

  const location = useLocation();

  const currentTab = [
    paths.preview,
    paths.summary,
    paths.details,
    paths.references,
  ].find((tab) => location.pathname.endsWith(`/${tab}`)) || 'details';

  const items = [
    {
      label: 'Preview',
      value: paths.preview,
      to: paths.preview,
    },
    {
      label: 'Summary',
      value: paths.summary,
      to: paths.summary,
    },
    {
      label: 'Details',
      value: paths.details,
      to: paths.details,
    },
  ];

  return (
    <TabsContainer currentTab={currentTab} items={items} />
  );
};